import React from 'react';
import { Flex } from '@balance-web/flex';
import { LoadingDots } from '@balance-web/loading';

export function DefaultLoader() {
  return (
    <Flex flexGrow={1} height="100vh" width="100vw">
      <LoadingDots label="loading flags" />
    </Flex>
  );
}
